export default "/build/client/static/fonts/SoderbergSans-BoldItalic.woff2";